/* OTAKU BEAT — free shipping bar, sticky add to cart, welcome popup */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function rate() {
    var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }
  function fmt(cents, currency) {
    var cur = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl', {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2);
    }
  }
  function store(key, value) {
    try {
      if (value === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      return null;
    }
  }
  function session(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var inflight = null;
  function getCart() {
    if (inflight) return inflight;
    inflight = fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { inflight = null; return c; })
      .catch(function (e) { inflight = null; throw e; });
    return inflight;
  }
  function refreshBars() {
    getCart().then(function (c) {
      document.querySelectorAll('ob-shipping-bar').forEach(function (b) { b.render(c.total_price, c.currency); });
    }).catch(function () {});
  }
  var hasPubSub = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  if (hasPubSub) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshBars, 50); });
  }
  document.addEventListener('cart:updated', refreshBars);

  /* ---------- FREE SHIPPING BAR ---------- */
  class ObShippingBar extends HTMLElement {
    connectedCallback() {
      this.wrap = this.querySelector('.ob-ship');
      this.textEl = this.querySelector('.ob-ship__msg');
      this.render(parseInt(this.dataset.total || '0', 10), this.dataset.currency);
      if (!this.dataset.static) refreshBars();
    }
    render(total, currency) {
      if (!this.wrap) return;
      var threshold = Math.round(parseFloat(this.dataset.threshold || '50') * 100 * rate());
      var remaining = Math.max(0, threshold - total);
      var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
      var state = total <= 0 ? 'empty' : remaining === 0 ? 'done' : 'progress';
      var msg;
      if (state === 'done') msg = this.dataset.msgDone;
      else if (state === 'empty') msg = (this.dataset.msgEmpty || '').replace('[amount]', '<strong>' + fmt(threshold, currency) + '</strong>');
      else msg = (this.dataset.msgProgress || '').replace('[amount]', '<strong>' + fmt(remaining, currency) + '</strong>');
      this.textEl.innerHTML = msg;
      this.wrap.dataset.state = state;
      this.wrap.style.setProperty('--fill', pct.toFixed(1) + '%');
      var track = this.querySelector('.ob-ship__track');
      if (track) track.setAttribute('aria-valuenow', Math.round(pct));
    }
  }
  if (!customElements.get('ob-shipping-bar')) customElements.define('ob-shipping-bar', ObShippingBar);

  /* ---------- Cart notification floats when page is scrolled ---------- */
  customElements.whenDefined('cart-notification').then(function () {
    var C = customElements.get('cart-notification');
    if (!C || C.prototype.__obPatched) return;
    var open = C.prototype.open;
    C.prototype.open = function () {
      var header = document.querySelector('.section-header') || document.querySelector('header');
      var bottom = header ? header.getBoundingClientRect().bottom : 0;
      if (this.notification) this.notification.classList.toggle('ob-floating', bottom < 0);
      refreshBars();
      return open.apply(this, arguments);
    };
    C.prototype.__obPatched = true;
  });

  /* ---------- STICKY ADD TO CART ---------- */
  class ObStickyAtc extends HTMLElement {
    connectedCallback() {
      this.sid = this.dataset.section;
      this.btn = this.querySelector('.ob-sticky__btn');
      this.btnLabel = this.querySelector('.ob-sticky__label');
      this.priceEl = this.querySelector('.ob-sticky__price');
      this.variantEl = this.querySelector('.ob-sticky__variant');
      this.btn.addEventListener('click', this.add.bind(this));

      var main = this.mainButton();
      if (!main) return;
      var target = main.closest('.product-form__buttons') || main;
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        self.toggle(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(target);

      this.sync();
      var info = document.querySelector('product-info[data-section="' + this.sid + '"]');
      if (info) {
        this.mo = new MutationObserver(function () {
          cancelAnimationFrame(self.raf);
          self.raf = requestAnimationFrame(function () { self.sync(); });
        });
        this.mo.observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value'] });
      }
      if (hasPubSub) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { self.sync(); }, 60); });
      }
    }
    mainButton() {
      return document.getElementById('ProductSubmitButton-' + this.sid);
    }
    toggle(show) {
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('ob-sticky-visible', show);
    }
    sync() {
      var main = this.mainButton();
      if (!main) return;
      this.btn.disabled = main.hasAttribute('disabled');
      var label = main.querySelector('span');
      if (label && label.textContent.trim()) this.btnLabel.textContent = label.textContent.trim();

      var price = document.getElementById('price-' + this.sid);
      if (price) {
        var onSale = price.querySelector('.price--on-sale');
        var html = '';
        if (onSale) {
          var reg = onSale.querySelector('.price__sale .price-item--regular');
          var sale = onSale.querySelector('.price__sale .price-item--sale');
          if (reg && reg.textContent.trim()) html += '<s>' + reg.textContent.trim() + '</s>';
          if (sale) html += '<span class="ob-sale">' + sale.textContent.trim() + '</span>';
        } else {
          var r = price.querySelector('.price__regular .price-item--regular');
          if (r) html = r.textContent.trim();
        }
        if (html) this.priceEl.innerHTML = html;
      }

      var info = document.querySelector('product-info[data-section="' + this.sid + '"]');
      var json = info && info.querySelector('[data-selected-variant]');
      if (json && this.variantEl) {
        try {
          var v = JSON.parse(json.textContent);
          this.variantEl.textContent = v && v.title && v.title !== 'Default Title' ? v.title : '';
        } catch (e) {}
      }
    }
    add() {
      var main = this.mainButton();
      if (!main) return;
      if (main.hasAttribute('disabled')) {
        main.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      main.click();
    }
  }
  if (!customElements.get('ob-sticky-atc')) customElements.define('ob-sticky-atc', ObStickyAtc);

  /* ---------- WELCOME POPUP ---------- */
  var KEY = 'ob_welcome_v1';
  var SUBMITTED = 'ob_welcome_submitted';
  class ObWelcome extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('.ob-welcome');
      this.formStep = this.querySelector('[data-step="form"]');
      this.codeStep = this.querySelector('[data-step="code"]');
      var self = this;

      this.querySelectorAll('[data-ob-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(true); });
      });
      this.modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(true); });

      var form = this.querySelector('form');
      if (form) form.addEventListener('submit', function () { session(SUBMITTED, '1'); });

      var copy = this.querySelector('.ob-welcome__copy');
      if (copy) copy.addEventListener('click', function () {
        var code = self.dataset.code;
        var done = function () { copy.textContent = copy.dataset.done; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
        else done();
      });

      var justSubmitted = session(SUBMITTED) === '1' || /ObWelcomeForm/.test(location.hash);
      if (justSubmitted && this.querySelector('[data-ob-success]')) {
        session(SUBMITTED, null);
        store(KEY, { s: 'done', t: Date.now() });
        this.showCode();
        this.open();
        return;
      }
      if (justSubmitted && this.querySelector('[data-ob-error]')) {
        session(SUBMITTED, null);
        this.open();
        return;
      }
      session(SUBMITTED, null);

      if (window.Shopify && Shopify.designMode) return;
      var saved = store(KEY);
      if (saved && (saved.s === 'done' || Date.now() - saved.t < 7 * 864e5)) return;

      var delay = parseInt(this.dataset.delay || '6', 10) * 1000;
      this.timer = setTimeout(function () { self.open(); }, delay);
      this.onLeave = function (e) {
        if (!e.relatedTarget && e.clientY <= 0) self.open();
      };
      if (window.matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', this.onLeave);
    }
    showCode() {
      if (this.formStep) this.formStep.hidden = true;
      if (this.codeStep) this.codeStep.hidden = false;
    }
    open() {
      if (this.isOpen) return;
      if (document.querySelector('.cart-notification.active')) {
        var self = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () { self.open(); }, 8000);
        return;
      }
      this.isOpen = true;
      clearTimeout(this.timer);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
      this.lastFocus = document.activeElement;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var first = this.modal.querySelector('input[type="email"]:not([hidden])') || this.modal.querySelector('.ob-welcome__close');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50);
    }
    close(remember) {
      this.isOpen = false;
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (remember) {
        var saved = store(KEY);
        if (!saved || saved.s !== 'done') store(KEY, { s: 'closed', t: Date.now() });
      }
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }
  }
  if (!customElements.get('ob-welcome')) customElements.define('ob-welcome', ObWelcome);
})();

/* ---------- Read more (product description) + carousel arrows ---------- */
(function () {
  'use strict';
  function initDesc(root) {
    (root || document).querySelectorAll('[data-ob-desc]').forEach(function (el) {
      if (el.__ob) return;
      el.__ob = true;
      var body = el.querySelector('.ob-desc__body');
      var btn = el.querySelector('.ob-desc__toggle');
      if (!body || !btn) return;
      var lh = parseFloat(getComputedStyle(body).fontSize) || 16;
      if (body.scrollHeight <= lh * 6.2) { el.classList.remove('is-collapsible'); return; } // short text: show it all
      el.classList.add('is-collapsible');
      btn.addEventListener('click', function () {
        var open = !el.classList.contains('is-open');
        el.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;
        if (!open) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  }
  function updateArrows(list) {
    var wrap = list.closest('.ob-carousel-wrap');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-ob-scroll="-1"]');
    var next = wrap.querySelector('[data-ob-scroll="1"]');
    if (prev) prev.disabled = list.scrollLeft <= 4;
    if (next) next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
  }
  function initCarousels() {
    document.querySelectorAll('.ob-carousel').forEach(function (list) {
      if (list.__ob) return;
      list.__ob = true;
      list.addEventListener('scroll', function () { updateArrows(list); }, { passive: true });
      updateArrows(list);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ob-scroll]');
    if (!btn) return;
    var list = btn.closest('.ob-carousel-wrap').querySelector('.ob-carousel');
    var item = list.querySelector('.ob-carousel__item');
    var step = item ? item.getBoundingClientRect().width + 16 : list.clientWidth * 0.8;
    list.scrollBy({ left: step * parseInt(btn.dataset.obScroll, 10) * 2, behavior: 'smooth' });
  });
  function run() { initDesc(); initCarousels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // related products are loaded later via fetch
  new MutationObserver(function () { initCarousels(); }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', function () { initDesc(); });
})();

/* ---------- WhatsApp links: always open in a new tab/app (never inside a frame) ---------- */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"]');
    if (!a) return;
    e.preventDefault();
    var url = a.href;
    var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile && window.top === window) { window.location.href = url; return; }
    var w = null;
    try { w = window.open(url, '_blank'); if (w) w.opener = null; } catch (err) {}
    if (!w) {
      if (window.top === window) { window.location.href = url; return; }
      try { window.top.location.href = url; } catch (err2) {
        // inside the Shopify editor: links to other sites are blocked there; show a hint instead of an error page
        a.setAttribute('data-ob-tip', 'Open the preview in a new tab to test WhatsApp');
        a.classList.add('ob-wa--tip');
        setTimeout(function () { a.classList.remove('ob-wa--tip'); }, 2600);
      }
    }
  }, true);
})();
